export const ROLES = {
    ADMIN: "ADMIN",
    MEMBER: "MEMBER",
    VIEWER: "VIEWER",
    UNAUTHORIZED: "UNAUTHORIZED",
};

export const DASHBOARD_ALLOWED_ROLES = [ROLES.ADMIN, ROLES.MEMBER];

export const INTERNAL_KB_ALLOWED_ROLES = [ROLES.ADMIN, ROLES.MEMBER, ROLES.VIEWER];

export const KB_TYPE = {
    INTERNAL: 'internal',
    EXTERNAL: 'external',
}

export const FEATURE_FLAG_NEW_AUTH = "rls-newauth-kb-service";
export const GMAIL = "Gmail";
export const OUTLOOK = "Outlook";
export const HIVER_GMAIL = "Hiver-Gmail";
export const HIVER_OUTLOOK = "Hiver-Outlook";
export const OUTLOOK_PRODUCT_TYPE = "hiver-for-outlook";
export const NAVIGATION_BUTTON_TEXT = "Go to {{product}}";
export const SEARCH_PLACEHOLDER = "Search across Hiver for {{product}}";
